export default {"src":"/_next/static/media/first_aid_kit.cc261994.svg","height":100,"width":100};